import { Component } from 'react';

class Menu extends Component {
  render() {
    return this.props.children;
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Dropdown/Menu/index.js